import moment from "moment";

export function AdapterReportOspiti(filter: any) {
    let filterMap: any;
    return filterMap = {
        DataDa: filter?.DataDa ? moment.tz(filter?.DataDa, "DD-MM-YYYY HH:mm", "Europe/Rome").toISOString() : '',
        DataA: filter?.DataA ? moment.tz(filter?.DataA, "DD-MM-YYYY HH:mm", "Europe/Rome").toISOString() : '',
        Sede: filter?.Sede?.value
    } 
}